import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const IndustriesMedia = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('reveal-show'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return (
    <>
      <div className="business-hero" style={{ background: 'linear-gradient(135deg, #4c0519, #be123c)' }}>
        <div className="hero-content">
          <h1 className="hero-title reveal-text">Media & Entertainment</h1>
          <p className="hero-subtitle reveal-text delay-1">Creating captivating content across multiple platforms – film, digital, and music</p>
        </div>
      </div>
      <div className="business-wrapper">
        <div className="container">
          <div className="category">
            <div className="category-header red"><h2>Our Entertainment Brands</h2><p>Bringing stories to life through cinema, digital content, and music</p></div>
            <div className="card-grid">
              <div className="business-card red reveal-card"><h3>AALI MOVIES</h3><p>Film production house creating compelling cinema that entertains and inspires audiences worldwide</p><Link to="/companies/aalimovies">Know More →</Link></div>
              <div className="business-card red reveal-card"><h3>AALI FILMZ</h3><p>Digital content studio specializing in web series, short films, and digital entertainment</p><Link to="/companies/aalifilmz">Know More →</Link></div>
              <div className="business-card red reveal-card"><h3>AALI MUSIC</h3><p>Music label and production company promoting diverse artists and creating chart-topping hits</p><Link to="/companies/aalimusic">Know More →</Link></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default IndustriesMedia;